<template>
  <div class="main div-layout">
    <div v-if="step==='upgrade'" class="systemUpgrade">
      <div class="systemUpgrade-main">
        <module-title title="家庭软件升级">
          <div class="right">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-plus"
              @click="opAddOrEdit('add')"
            >
              新增应用
            </el-button>
          </div>
        </module-title>

        <div class="systemUpgrade-main-contain">
          <el-form
            :model="searchForm"
            :inline="true"
            label-position="right"
            label-width="100px"
          >
            <el-form-item label="名称：" prop="name">
              <el-input
                v-model="searchForm.name"
                :maxlength="20"
                name="name"
                class="handle-form-input"
                clearable
              />
            </el-form-item>
            <el-form-item label="升级类型：" prop="platformTypeId">
              <el-select
                v-model="searchForm.platformTypeId"
                name="platformTypeId"
                size="medium"
                class="handle-form-input"
                @change="handlePlatform"
              >
                <el-option label="全部" value />
                <el-option
                  v-for="item in platformList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item style="margin-left:50px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleSearchFilter"
              >
                查询
              </el-button>
            </el-form-item>
            <el-form-item style="margin-left:50px;">
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-search"
                @click="handleWhiteslist"
              >
                白名单
              </el-button>
            </el-form-item>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="applicationList"
            highlight-current-row
            fit
            element-loading-text="Loading"
            class="list-table"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="LOGO" prop="logoUrl" align="center">
              <template slot-scope="scope">
                <img v-show="scope.row.logoUrl" :src="scope.row.logoUrl" width="48" height="48">
              </template>
            </el-table-column>
            <el-table-column label="应用名称" prop="name" align="center" />
            <el-table-column label="应用描述" prop="remark" align="center" />
            <el-table-column label="编码" prop="code" align="center" />
            <el-table-column label="升级类型" prop="platformTypeName" align="center" width="138" />
            <el-table-column label="版本号" prop="versionName" align="center" />
            <el-table-column label="更新日期" prop="releseDate" align="center" width="168">
              <template slot-scope="scope">
                {{ scope.row.releseDate }}
              </template>
            </el-table-column>
            <el-table-column label="升级方式" prop="forcedUpgrade" align="center">
              <template slot-scope="scope">
                <span v-show=" scope.row.forcedUpgrade===3">自检</span>
                <span v-show=" scope.row.forcedUpgrade===2">推荐</span>
                <span v-show=" scope.row.forcedUpgrade===1">强制</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="320px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="opAddOrEdit('edit',scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-link"
                  @click="gotoVersionMange(scope.row)"
                >
                  版本管理
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-link"
                  @click="handleOfficiallaunch(scope.row)"
                >
                  正式发布
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="searchForm.total"
            :page.sync="searchForm.pageNum"
            :limit.sync="searchForm.pageSize"
            @pagination="pageCurriculumList"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <!-- 新增编辑升级 -->
      <el-dialog
        v-if="hiddenVariable.dialogEditVisible"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogEditVisible"
        :title="handleType==='add'?'新增应用':'编辑应用'"
        width="700px"
        @close="handleDialogClose"
      >
        <el-form
          ref="addApplicationForm"
          :model="addApplicationForm"
          :rules="handleRules"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="应用名称：" prop="name">
            <el-input
              v-model="addApplicationForm.name"
              placeholder="请输入应用名称"
              :maxlength="30"
              name="name"
              class="handle-form-input"
            />
          </el-form-item>
          <el-form-item label="业务分类：" prop="appGenreCode">
            <el-select
              v-model="addApplicationForm.appGenreCode"
              name="appGenreCode"
              size="medium"
              class="handle-form-input"
            >
              <el-option
                v-for="item in appGenreList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="应用类型：" prop="platformTypeId">
            <el-select
              v-model="addApplicationForm.platformTypeId"
              name="platformTypeId"
              size="medium"
              class="handle-form-input"
            >
              <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="应用标识：" prop="code">
            <el-input
              v-model="addApplicationForm.code"
              placeholder="请输入应用标识"
              name="code"
              class="handle-form-input"
            />
            <el-tooltip
              class="item"
              effect="dark"
              content="
              可输入10个字符，字符类型为数字、字母，不可输入已存在的应用标识。"
              placement="right"
            >
              <span>
                <img width="30px" class="tips-img" src="@/assets/img/tips.png" alt="">
              </span>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="应用图标：" prop="logoUrl">
            <upload-file
              :props="{serveCode:'app_logo',accept:'.png, .jpg, .jpeg',type:['image/jpeg','image/gif','image/png']}"
              @uploadSucess="uploadSucessImgFn"
            >
              <div v-if="addApplicationForm.logoUrl" style="font-size:12px;line-height: 28px;">
                <img :src="addApplicationForm.logoUrl" class="avatar">
                <i class="el-icon-refresh" /> <span>重新上传</span>
              </div>

              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </upload-file>
            <!-- <img   :src="addApplicationForm.logoUrl"  class="avatar"/> -->
          </el-form-item>
          <el-form-item label="应用描述：" prop="remark">
            <el-input
              v-model="addApplicationForm.remark"
              :rows="4"
              type="textarea"
              :maxlength="1000"
              name="remark"
              class="handle-form-input"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <!-- <el-button size="medium" @click="hiddenVariable.dialogEditVisible = false">取消</el-button> -->
          <el-button
            :loading="ajaxLoading"
            type="primary"
            size="medium"
            @click="handleAddUpgrade"
          >
            {{ ajaxLoading?'Loading':'确定' }}
          </el-button>
        </div>
      </el-dialog>

      <el-dialog
        v-if="hiddenVariable.dialogEditWhites"
        :close-on-click-modal="false"
        :visible.sync="hiddenVariable.dialogEditWhites"
        title="预升级白名单"
        width="700px"
        @close="handleWhitesClose"
      >
        <el-form
          :model="searchForm"
        >
          <el-form-item label="" prop="contentWhites">
            <el-input
              v-model="contentWhites"
              :rows="10"
              type="textarea"
              placeholder="请输入预升级白名单"
              class="textareaText"
              clearable
            />
          </el-form-item>
          <div class="tip">
            通过“#”进行分割
          </div>

          <el-form-item style="text-align:center">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleCunwappwhitesAdd"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <app-white v-else-if="step==='appWhite'" @back="back" />
    <version-manage v-else :version-prpos="versionPrpos" @back="back" />
  </div>
</template>

<script>

import VersionManage from './versionManage';
import AppWhite from './appWhite';

import { formatTimeToStr } from '@/utils/index';
import {
  getDictsType
} from '@/api/productOperation/common/applicationManage';
import {
  getUpgradeAppList,
  addApplicationUpgrade,
  editApplicationUpgrade,
  updateApplicationUpgradeStatus,
  selectHomeConfig
} from '@/api/systemMaintenance/upgradeManage/systemUpgrade';

import {
  getCunwappwhitesAdd,
  getCunwappOfficiallaunch
} from '@/api/systemMaintenance/upgradeManage/preRelease';

import { mapGetters } from 'vuex';
export default {
  name: 'SystemUpgrade',
  components: {
    VersionManage,
    AppWhite
  },
  data() {
    return {
      ajaxLoading: false,
      step: 'upgrade',
      // 弹框标题
      handleType: 'add',
      // 所有控制显示隐藏变量
      hiddenVariable: {
        dialogEditVisible: false,
        dialogEditWhites: false
      },
      // 搜索表单
      searchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        appType: 2,
        platformTypeId: '',
        appGenreCode: '',
        name: ''
      },

      addApplicationForm: {
        name: '',
        logoPath: '',
        logoUrl: '',
        code: '',
        platformTypeId: '',
        appGenreCode: '',
        appType: 2,
        remark: ''
      },
      versionPrpos: {
        platformTypeId: '',
        platformTypeName: '',
        cunwAppId: '' //   当前应用id
      },
      contentWhites: '',
      listLoading: false, // 表格刷新loading
      applicationList: [],
      platformList: [], //  平台列表
      appGenreList: [], // 业务分类列表
      handleRow: {},
      handleRules: {
        platformTypeId: [{ required: true, message: '应用类型不能为空', trigger: 'blur' }],
        appGenreCode: [{ required: true, message: '业务分类不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '应用标识不能为空', trigger: 'blur' }, { max: 10, message: '请输入10以内的字符', trigger: 'blur' }],
        logoUrl: [{ required: true, message: '应用图标不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '应用名称不能为空', trigger: 'blur' }, { max: 30, message: '请输入50以内的字符', trigger: 'blur' }]
      }
    };
  },
  computed: {
    // 获取上传图片地址
    ...mapGetters(['uploadUrl']),
    formatTimeToStr() {
      return formatTimeToStr;
    }
  },
  mounted() {
    this.fetchApplicationList();
    this.fetchPlatformList();
  },
  methods: {
    selectName(val) {
      var data = {
        name: val
      };
      selectHomeConfig(data).then(res => {
        this.addApplicationForm.platformTypeId = res.data.platformTypeId;
        this.addApplicationForm.code = res.data.code;
        this.addApplicationForm.appGenreCode = res.data.appGenreCode;
      });
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchApplicationList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchApplicationList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchApplicationList();
    },
    handleWhiteslist() {
      // this.hiddenVariable.dialogEditWhites = true;
      // getCunwappwhites()
      //   .then(result => {
      //     this.contentWhites = result.data.content;
      //   });
      this.step = 'appWhite';
    },
    handleCunwappwhitesAdd() {
      var option = {
        content: this.contentWhites
      };
      getCunwappwhitesAdd(option)
        .then(result => {
          this.hiddenVariable.dialogEditWhites = false;
          this.fetchApplicationList();
        });
    },
    handleWhitesClose() {
      this.hiddenVariable.dialogEditWhites = false;
    },
    // 打开新增编辑弹框
    opAddOrEdit(type, row) {
      this.handleDialogClose();
      this.handleType = type;
      this.hiddenVariable.dialogEditVisible = true;
      if (type === 'edit') {
        this.handleRow = row;
        const { name, code, platformTypeId, remark, logoUrl, appGenreCode } = row;
        this.addApplicationForm = {
          name, code, logoUrl, platformTypeId, remark, appGenreCode, appType: 2
        };
      }
    },
    // 重置
    handleDialogClose() {
      this.addApplicationForm = {
        name: '',
        logoPath: '',
        logoUrl: '',
        code: '',
        platformTypeId: '',
        appGenreCode: '',
        appType: 2,
        remark: ''
      };
      // this.searchForm.platformTypeId = '';
    },

    back() {
      this.step = 'upgrade';
      this.fetchApplicationList();
    },
    uploadSucessImgFn(val) {
      this.$forceUpdate();
      this.$set(this.addApplicationForm, 'logoUrl', val.absolutePath);
      this.$set(this.addApplicationForm, 'logoPath', val.relativePath);
      this.$refs.addApplicationForm.validateField('logoUrl');
    },

    // 跳转版本管理页面
    gotoVersionMange(row) {
      this.versionPrpos = {
        cunwAppId: row.id,
        platformTypeId: row.platformTypeId,
        platformTypeName: row.platformTypeName,
        releaseType: row.releaseType
      };

      this.step = 'version';
    },
    handleOfficiallaunch(row) {
      this.$confirm(`正式发布后，所以用户都将接收升级信息！<p>是否确定继续发布？</p>`, {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '发布',
        cancelButtonText: '取消',
        center: true
      })
        .then(res => {
          var option = {
            cunwAppId: row.id
          };
          getCunwappOfficiallaunch(option)
            .then(result => {
              this.fetchApplicationList();
            });
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 新增编辑应用升级
    handleAddUpgrade() {
      this.$refs['addApplicationForm'].validate(valid => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.handleType === 'add') {
            addApplicationUpgrade(this.addApplicationForm)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '添加成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchApplicationList();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          } else {
            editApplicationUpgrade(this.handleRow.id, this.addApplicationForm)
              .then(result => {
                this.$notify.success({
                  title: 'Success',
                  message: '编辑成功',
                  showClose: false,
                  duration: 2000
                });
                this.ajaxLoading = false;
                this.hiddenVariable.dialogEditVisible = false;
                this.fetchApplicationList();
              })
              .catch(err => {
                console.log(err);
                this.ajaxLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          this.ajaxLoading = false;
          return false;
        }
      });
    },
    // 删除应用
    deleteAddApplication(row) {
      // 移除成员
      this.$confirm(`确定要移除该应用升级么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() =>
          updateApplicationUpgradeStatus({ ids: [row.id], status: -1 })
        )
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchApplicationList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    handlePlatform(val) {
      this.searchForm.platformTypeId = val;
    },
    // 获取应用列表
    fetchApplicationList() {
      this.listLoading = true;
      getUpgradeAppList(this.searchForm)
        .then(result => {
          this.applicationList = result.data.list;
          this.searchForm.total = result.data.total;
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.applicationList = [];
          this.searchForm.total = 0;
        });
    },
    // 获取平台字典
    fetchPlatformList(type) {
      getDictsType('platform_type')
        .then(result => {
          this.platformList = result.data;
        })
        .catch(err => {
          console.log(err);
        });
      getDictsType('app_genre')
        .then(result => {
          this.appGenreList = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss">
.systemUpgrade {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
}
</style>
<style lang="scss" scoped>
.systemUpgrade {
  padding-bottom: 20px;
  .el-date-editor.el-input {
    margin-left: 20px;
  }
  .handle-form-input {
    width: 80%;
  }
  .tips-img{
  position: absolute;
  top: 2px;
  right: 65px;
  cursor: pointer;
}
}
</style>
